import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsletterApiService extends ApiBaseService {
  override scope = 'newsletter';

  subscribe(email: string): Observable<JSON> {
    return this.post<JSON>({email: email}, 'subscribe');
  }

  unsubscribe(token: string): Observable<JSON> {
    return this.post<JSON>({token: token}, `unsubscribe/${token}`);
  }
}
